// extracted by mini-css-extract-plugin
export default {"changePasswordWrapper":"ChangePassword_changePasswordWrapper__5WRDJ"};